export default "__VITE_ASSET__C08bJ_Zo__"